import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function safeNumber(value: any): number {
  const num = Number(value);
  return isNaN(num) ? 0 : num;
}

export function safeFormatPLN(value: number | undefined | null): string {
  const num = safeNumber(value);
  return num.toLocaleString('pl-PL', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' PLN';
}
